import { ProfileForm } from '@/entities/profile-page/ProfileForm/ui/ProfileForm'
import './ui/ProfileForm.css'
export default ProfileForm
